import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';

const MessageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem 0 1.5rem;
`;

const MessageIconBox = styled.div`
  flex-shrink: 0;
  width: 2.75rem;
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
  border-radius: 0.5rem;
  color: #008995;
  font-size: 1.25rem;
`;

const MessageText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const MessageTitle = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a2b3c;
`;

const MessageDescription = styled.p`
  margin: 0;
  font-size: 0.9375rem;
  color: #6b7280;
  line-height: 1.5;
`;

type Props = {
  title: string;
  description: string;
};

const MessagePageHeader: React.FC<Props> = ({ title, description }) => (
  <MessageHeader>
    <MessageIconBox>
      <FontAwesomeIcon icon={faBullhorn} />
    </MessageIconBox>
    <MessageText>
      <MessageTitle>{title}</MessageTitle>
      <MessageDescription>{description}</MessageDescription>
    </MessageText>
  </MessageHeader>
);

export default MessagePageHeader;
